<template>
  <span v-show="hasMenuItems">
    <button v-if="!singleMode" data-toggle="dropdown" :class="['btn', 'btn-default', buttonClass, border ? '' : 'btn-no-border', tableAction ? 'btn-xxs' : '']" type="button">
      <i :class="['far', 'fa-ellipsis-h', !tableAction ? 'fa-lg' : '']"></i>
    </button>
    <ul class="dropdown-menu dropdown-menu-right" v-if="!singleMode">
      <slot />
    </ul>
    <span v-if="singleMode">
      <slot />
    </span>
  </span>
</template>

<style scoped>
.btn-no-border, .btn-no-border:active, .btn-no-border:focus {
  background-color: transparent;
  border-color: transparent;
}
.btn-no-border:hover {
  border: 1px solid #e7eaec;
  transition: none;
}
</style>

<script>
// Note: We register menu items so we can dynamically change the look & feel of the action drop menus (for table actions)
// If there is only 1 menu item, it's displayed as an icon without a dropdown to speed up the user using the system
export default {
  provide() {
    return {
      actionDropMenu: this
    }
  },
  props: {
    title: String,
    icon: {
      type: String,
      default: ''
    },
    border: {
      type: Boolean,
      default: true
    },
    buttonClass: {
      type: String,
      default: "btn-sm"
    },
    tableAction: {
      type: Boolean,
      default: false
    },
    forceDropdown: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    registeredMenuItems(newVal, oldVal) {
      this.$nextTick(() => {
        this.updateMenuItems()
      })
    }
  },
  computed: {
    hasMenuItems() {
      return this.registeredMenuItems.length > 0
    }
  },
  data() {
    return {
      registeredMenuItems: [],
      singleMode: false
    }
  },
  methods: {
    registerMenuItem(item) {
      if(!this.registeredMenuItems.find(i => i === item)) {
        this.registeredMenuItems.push(item)
        item.$once('hook:destroyed', () => {
          this.unregisterMenuItem(item)
        })
      }
    },
    unregisterMenuItem(item) {
      this.registeredMenuItems = this.registeredMenuItems.slice().filter(i => i !== item)
    },
    updateMenuItems() {
      if(!this.tableAction)
        return

      this.singleMode = this.registeredMenuItems.length == 1 && !this.$props.forceDropdown

      this.registeredMenuItems.forEach(menuItem => {
        menuItem.singleMode = this.singleMode
      })      
    }
  }
}
</script>